import * as React from "react";
import { forwardRef } from "react";
const SvgSelected = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeLinejoin: "round" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeWidth: 1.5, d: "M12 15V9m10 13H2L12 2z" }), /* @__PURE__ */ React.createElement("path", { d: "M12.5 18.5a.5.5 0 0 1-1 0 .5.5 0 0 1 1 0z" })));
const ForwardRef = forwardRef(SvgSelected);
export { ForwardRef as ReactComponent };
